const Header = () => {
  return (
    <header className="header">
      <i className="fa-solid fa-list-check"></i>
      <p>Task Minder</p>
    </header>
  );
};

export default Header;
